import script from "./ModuleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleCard.vue?vue&type=script&setup=true&lang=js"

import "./ModuleCard.vue?vue&type=style&index=0&id=7eab2685&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eab2685"]])

export default __exports__